<template>
    <!-- Same <i> box the icon font used (1em glyph on the text line), so size/colour classes still apply. -->
    <i class="app_icon" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" fill="none">
            <component :is="tag" v-for="([tag, attrs], i) in nodes" :key="i" v-bind="attrs" />
        </svg>
    </i>
</template>

<script setup>
import { computed } from 'vue'
import { icons } from '~/utils/icons'

const props = defineProps({
    name: { type: String, required: true },
})

// Icon data uses React-style camelCase attributes (strokeWidth); SVG needs stroke-width.
const kebab = (key) => key.replace(/[A-Z]/g, (c) => `-${c.toLowerCase()}`)

const nodes = computed(() =>
    (icons[props.name] || []).map(([tag, attrs]) => [
        tag,
        Object.fromEntries(Object.entries(attrs).filter(([k]) => k !== 'key').map(([k, v]) => [kebab(k), v])),
    ]),
)
</script>

<style>
/* Same vertical metrics as the old icon font (ascent 1em, descent 0), so the <i> takes the same
   line box it used to and the SVG sits on the baseline like the glyph did. Local font only. */
@font-face {
    font-family: 'app-icon-metrics';
    src: local('Arial'), local('Helvetica'), local('Roboto'), local('DejaVu Sans'), local('Liberation Sans');
    ascent-override: 100%;
    descent-override: 0%;
    line-gap-override: 0%;
}
</style>

<style scoped>
.app_icon {
    font-family: 'app-icon-metrics';
    font-style: normal;
    position: relative;
}
.app_icon svg {
    display: inline-block;
    vertical-align: baseline;
}
</style>
